import memoize from 'lodash/memoize';
import sanitizeArticleLink from 'sanitizers/sanitizeArticleLink';
import { ArticleLink } from 'types';

export default memoize((articleLinks: unknown[]): ArticleLink[] => {
  return articleLinks.map(sanitizeArticleLink);
});
